var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8967012989b35130c450f631e717d404.js').default;export default
        Object.assign({}, scope_0 )
    